import script from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&setup=true"

import "./MultiSelect.vue?vue&type=style&index=0&id=5edf5e58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5edf5e58"]])

export default __exports__